export default "__VITE_PUBLIC_ASSET__a157c8d6__"